
import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { LanguageForm } from '@/components/forms/LanguageForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateLanguagePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/system-settings/language/languages')
  }

  const handleCancel = () => {
    navigate('/system-settings/language/languages')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Add Language</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new language to the system.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <LanguageForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

